export const SHEET_DISMISS_THRESHOLD_PX = 80;

export function shouldDismissSheet({
  deltaY,
  deltaX = 0,
  thresholdPx = SHEET_DISMISS_THRESHOLD_PX,
}: {
  deltaY: number;
  deltaX?: number;
  thresholdPx?: number;
}): boolean {
  if (deltaY < thresholdPx) {
    return false;
  }
  return deltaY > Math.abs(deltaX);
}
